import React, { Component } from "react";
import {  Row, Col, Button, ListGroup, Form, Alert , Modal } from "react-bootstrap";

//import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import ReactTable from "react-table";


import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Creatable from 'react-select/creatable';

export default class AppendixTotals extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "appendix_totals",
            dataRecord: "appendix_total",
            dataSetPrimaryKey: "appendix_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        this.setState({ isLoading: true });     
        if (!this.props.isAuthenticated) { // if false
            return;
        }                        

        this.setState({ isLoading: false });      
    }

    



    componentWillUnmount() {
        this.setState({ addresses: [] });
    }



    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }

   

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete address");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleFrontageChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        val = Math.round(parseFloat(val) * 100) / 100; //Round to 2 decimal places
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    
    

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            // const result = await this.handleDataSave(data[i]);
                            // if (result.result) {
                            //     data[i].modified = false;
                            //     if (data[i].hasOwnProperty("new_record")) {
                            //         if (data[i].new_record === true) {

                            //             data[i][this.state.dataSetPrimaryKey] = result.id;
                            //             this.setState({ savingNewRecord: false });
                            //         }
                            //         data[i].new_record = false;
                            //     }
                                                               
                            // }
                            // else {
                            //     this.setState({ errorMessage: result.error_message });
                            //     this.setState({ showAlert: true });
                            // }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (data[0].hasOwnProperty("appendix")) {
            data.sort(function (a, b) { return a.appendix - b.sort_order });
        }
        
        this.props.updateTableState(data, this.state.dataSet);

    }

    

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        // data.push({
        //     property_id: this.props.filter.propertyid,
        //     street_name: "",
        //     main_address: false,
        //     odd_even: false,
        //     sort_order: this.props.data.length+1,
        //     street_num_low: null,
        //     street_num_low_suffix: null,
        //     street_num_high: null,
        //     street_num_high_suffix: null,
        //     frontage: null,
        //     known_as: null,
        //     rp_data_id: null,
        //     auto_match: false,
        //     manual_match: false,
        //     created_by: this.props.user,
        //     last_edited_by: this.props.user,
        //     new_record: true

        // });
        // this.props.updateTableState(data, this.state.dataSet);
    }

    
    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

    


    renderTable(data) {
        const columns = [{
            id: 'appendix',
            Header: 'Appendix',
            accessor: 'appendix',                                          
            style: { 'whiteSpace': 'unset' } 
        }
        ,{
            id: 'issue_date',
            Header: 'Issue Date',
            accessor: 'issue_date',                                          
            style: { textAlign: "center" },
            Cell: this.renderEditable
        }
        ,{
            id: 'group',
            Header: 'Group',
            accessor: 'group',                                          
            style: { textAlign: "center" },
             Cell: this.renderEditable
        }
       

        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }

    }

   

    renderComponent() {
        return (
            <div className="appendix_totals">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
              

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        { !this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : "" }
                        </Col>
                    </Row>
               

            </div>
        );
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="AppendixSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
  }
}
